import React, { Component } from "react";
import styled from "styled-components";
import { connectModal } from "redux-modal";
import {
  ControlGroup,
  Button,
  Modal,
  ModalContent,
  ModalFooter,
  spacing,
} from "@conserveit/blocks";
import PropTypes from "prop-types";
import { t } from "@lingui/macro";
import { I18n } from "@lingui/react";

const StyledForm = styled.form`
  padding: ${spacing.loose};
`;

const StyledModal = styled(Modal)`
  .Modal-content > section {
    min-height: 200px;
  }
`;
export const ATTACHMENT_MODAL = "ATTACHMENT_MODAL";
class AttachmentModal extends Component {
  static propTypes = {
    endUploadAttachment: PropTypes.func.isRequired,
    handleAddAttachment: PropTypes.func.isRequired,
    uploadAttachment: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      isFilePresent: false,
    };
  }

  setFilePresent = ({ target }) => {
    // If file present, enable `Add` button
    this.setState({
      isFilePresent: target.value.length > 0,
    });
  };

  handleAddAttachment = () => {
    const file = this.inputUpload.files[0];

    const reader = new FileReader();

    // Wait for preview URL to Load
    reader.onloadend = () => {
      const key = new Date().getTime();
      const attachment = {
        key,
        file,
        fileName: file.name,
        fileType: file.type,
        id: this.props.id,
        previewUrl: reader.result,
      };

      // Store file attributes to redux
      this.props.handleAddAttachment(attachment);
      this.props.handleHide();
    };
    reader.readAsDataURL(file);
  };

  handleClose = () => {
    // Reset pristine state to ensure button is disabled when modal is opened
    this.setState({
      isFilePresent: false,
    });

    // Close Modal
    this.props.endUploadAttachment();
  };

  render() {
    const { show, handleHide } = this.props;

    return (
      <I18n>
        {({ i18n }) => (
          <StyledModal
            title={i18n._(t("attachment_modal.add_attachment")`Add Attachment`)}
            isOpen={show}
            onRequestClose={handleHide}
          >
            <ModalContent>
              <StyledForm name="form-group" id="formUpload">
                <input
                  id="inputUpload"
                  type="file"
                  onChange={this.setFilePresent}
                  ref={(ref) => {
                    this.inputUpload = ref;
                  }}
                />
              </StyledForm>
            </ModalContent>
            <ModalFooter>
              <ControlGroup tight>
                <Button thin appearance="outline" onClick={handleHide}>
                  Cancel
                </Button>
                <Button
                  thin
                  additive
                  onClick={this.handleAddAttachment}
                  disabled={!this.state.isFilePresent}
                >
                  {i18n._(t("attachment_modal.add")`Add`)}
                </Button>
              </ControlGroup>
            </ModalFooter>
          </StyledModal>
        )}
      </I18n>
    );
  }
}

const ConnectedAttachmentModal = connectModal({
  name: ATTACHMENT_MODAL,
  getModalState: (state) => state.betaModal,
})(AttachmentModal);

export default ConnectedAttachmentModal;
